// We want our initial chunk to be as small as possible so that we download it quickly and show a loading screen immediately
// Imports here should be carefully considered such that they don't significantly increase the initial download size
import React, { useCallback, useState } from "react";
import { createRoot } from "react-dom/client";
import type { LoadingError } from "./components/LoadingScreen/LoadingScreen";
import { LoadingScreen } from "./components/LoadingScreen/LoadingScreen";
import { setupInitialTheme } from "./components/LoadingScreen/setupInitialTheme";
import { trackChunkLoadDiagnostics } from "./routing/chunkLoadDiagnostics";
import { trackChunkLoadErrors } from "./routing/isChunkLoadError";

const App = React.lazy(() => import("./App"));

trackChunkLoadErrors();
trackChunkLoadDiagnostics(import.meta.url);
setupInitialTheme();

function render(Component: typeof AppWithLoading) {
    const container = document.getElementById("app");
    // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion
    const root = createRoot(container!);
    root.render(<Component />);
}

function AppWithLoading() {
    const [isReady, setIsReady] = useState(false);
    const [loadingError, setLoadingError] = useState<LoadingError>();

    const onReady = useCallback(() => setIsReady(true), [setIsReady]);

    return (
        <>
            <React.Suspense fallback={null}>
                <App onReady={onReady} onInitialLoadError={setLoadingError} />
            </React.Suspense>
            {!isReady && <LoadingScreen error={loadingError} />}
        </>
    );
}

render(AppWithLoading);
